import { map, prop } from 'ramda';

const About = data => {
  const ads = map(prop("content"), data.adv || {});

  return ({
    ...data.story,
    content: {
      ...data.story.content,
      ads: {
        header_banner_panel: ads.header_banner_panel,
        lower_banner_panel: ads.lower_banner_panel
      }
    }
  })
}

export { About }
